import React from "react";

const CartItemDropdownListItem = ({ children, ...props }) => {
  return <div className="wbmcil-dropdown-item">{children}</div>;
};

export default CartItemDropdownListItem;
